import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HlsPlayer from '../hlsplayer/HlsPlayer';

function VideoPlayerPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get video URL from query param
  const query = new URLSearchParams(location.search);
  const src = query.get("src");

  return (
    <div className="w-screen h-screen bg-black flex flex-col">
      {/* Back Button */}
      <button
        // onClick={() => navigate("/")}
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 bg-white px-4 py-2 rounded shadow-md"
      >
        ← Back
      </button>

      {/* Player */}
      <div className="flex-1 flex items-center justify-center">
        <HlsPlayer src={src} autoPlay controls style={{ width: "100%", height: "100%" }} />
      </div>
    </div>
  );
}

export default VideoPlayerPage;
